<template>
  <div class="patientDetail">
    <PatientDetail v-if="!isEmrDoctor" backRoute="OrgOwnerPatientDetail" @viewPatientFiles="viewPatientFiles" />
    <PatientDetail2 v-else backRoute="OrgOwnerPatientDetail" @viewPatientFiles="viewPatientFiles" />
    <PatientTreatmentList v-if="!isEmrDoctor" treatmentHistoryDetailRoute="OrgOwnerPatientTreatmentDetail" />
    <PatientTreatmentList2 v-else treatmentHistoryDetailRoute="OrgOwnerPatientTreatmentDetail" />
  </div>
</template>

<script>
import PatientDetail from '@/views/components/patients/Detail';
import PatientDetail2 from '@/views/components/patients/Detail2';
import PatientTreatmentList from '@/views/components/patients/PatientTreatmentList';
import PatientTreatmentList2 from '@/views/components/patients/PatientTreatmentList2';

export default {
  components: {
    PatientDetail,
    PatientDetail2,
    PatientTreatmentList,
    PatientTreatmentList2,
  },
  computed: {
    isEmrDoctor() {
      return JSON.parse(localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)).doctorEMRClinics.length;
    },
  },
  methods: {
    viewPatientFiles(id) {
      this.$router.push({
        name: 'OrgOwnerPatientFiles',
        params: { patientId: id },
      });
    },
  },
};
</script>
